export default __webpack_public_path__ + "static/media/before-footer-img3.e15dd552.png";